module.exports = __webpack_public_path__ + "static/media/ageelementfirmingeyecontour.f3e58b91.png";